import { Component } from '@angular/core';
import { Observable, shareReplay, tap } from 'rxjs';
import { GtmEvent } from 'src/app/interfaces/gtm.interface';
import { TextErrorContentUI } from 'src/app/interfaces/text-content.interface';
import { ErrorService } from 'src/app/services/error/error.service';
import { GtmService } from 'src/app/services/gtm/gtm.service';
import { Patterns } from 'src/app/utils/constants';

@Component({
	selector: 'app-error',
	templateUrl: './error.component.html',
	styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
	errorText$: Observable<TextErrorContentUI> = this.errorService.errorText$.pipe(
		tap(({ tags }) => {
			if (tags?.page) this.gtmService.handlerEvent(tags.page);
		}),
		shareReplay(1)
	);

	constructor(
		private readonly errorService: ErrorService,
		private readonly gtmService: GtmService
	) {}

	onButtonActionHandler(action: string, tagAction?: GtmEvent): void {
		if (tagAction) this.gtmService.handlerEvent(tagAction);
		if (Patterns.externalUrl.test(action)) window.location.assign(action);
	}
}
